<div >

  <div class="row">
    <div class="col-md-12">
      <div class="card margin-top-10 width-802px">
        <div class="card-header wh-header header3 ">
          <div class="row">
            <div class="col-md-4">
              <label>Consultant Map</label>
            </div>
            <div class="col-md-8 float-right text-align-end">
              <!--<button type="button" (click)="Addconsultant()" class="btn btn-primary btn-sm nav-link-hand"><i class="fas fa-plus"></i></button>-->
              <a (click)="Editconsultant()" class="nav-link-hand education-navlink">
                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body padding-top-0 padding-left-0px">

          <div class="card alerts-note-form ">
            <div class="card-body padding-top padding-left-8 padding-right-9 " *ngIf="ShowList">


              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="">Branch</th>

                        <th class="">Consultant</th>
                        <th class="">Provider Cost</th>
                        <th class="">Comnsn Factor</th>

                        <th class="text-align-right">Commsn%</th>
                        <th class="text-align-right">Commsn Amt</th>
                        <th class="text-align-right">Commsn Total</th>

                        <!--<th class=""></th>-->




                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr>


                        <td class=" td-padding "> Drug Administartion</td>
                        <td class=" td-padding text-align-center"> A S Vijay</td>
                        <td class=" td-padding text-align-right">100</td>
                        <td class=" td-padding text-align-center">Fixed</td>

                        <td class=" td-padding text-align-right">0</td>

                        <td class=" td-padding text-align-right">100</td>

                        <td class="  text-align-right">0</td>
                        <!--<td class=" td-padding text-align-center">
                          <button type="button" (click)="edit_()"
                                  class="btn  actions-btn-prime2 benfits-button font-size margin-left-zero border-color " title="Edit">

                            <i class="fas fa-pencil-alt color-edit-icon"></i>
                          </button>
                        </td>-->




                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

